<template v-if="$parent.isModalVisible2" lang="pug">
div.h-100(name='modal2')
  .modal-mask.h-100(v-on:mousedown.self="$emit('close')")
    transition(name='slide-fade')
      .modal-container.col-6.h-100(v-if='$parent.isModalVisible2')
        .modal-header
          slot(name='header2')
            h2 Модальное окно второго уровня
          span.btn-close.btn-right.border-0.bg-transparent.text-center(type='button' v-on:click='$parent.closeModal2' aria-label='Close modal' style='padding:5px 10px;cursor:pointer;')
            i.fas.fa-times
        div(v-bind:class="['modal-body']")
          slot(name='body2')
        div(v-bind:class="['modal-footer']")
          slot(name='footer2')
</template>
<script>/* eslint-disable */
  export default {
    data () {
      return {
      }
    },
    mounted() {
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modal2.vue